import { IOfferSpendByOfferListTableLang } from '../../../types/lang'

export const offerSpendByOfferListTableLang: IOfferSpendByOfferListTableLang = {
	offer_spend_by_offer_list_table: {
		column_offer_id: 'Offer ID',
		column_offer: 'Offer',
		column_offer_in_group: 'Offer in Group',
		column_country: 'Country',
		column_amount: 'Amount',
		column_date: 'Date',
	}
}